import React, { useEffect, useState } from 'react';
import { Box, Typography, LinearProgress, LinearProgressProps, SxProps, Theme } from '@mui/material';

interface ProgressBarProps {
  current: number;
  total: number;
  label?: string;
  color?: LinearProgressProps['color'];
  sx?: SxProps<Theme>;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  current,
  total,
  label = 'Processed Shipments',
  color = 'primary',
  sx,
}) => {
  const [dotIndex, setDotIndex] = useState(0);
  const percentage = total > 0 ? (current / total) * 100 : 0;
  const dotStages = ['   ', '.  ', '.. ', '...'];

  useEffect(() => {
    const interval = setInterval(() => {
      setDotIndex(prev => (prev + 1) % dotStages.length);
    }, 500); // Update every 0.5s

    return () => clearInterval(interval);
  }, []);

  return (
    <Box width="60%" p={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="body1" sx={{ whiteSpace: 'pre', fontSize: '16px' }}>
          {label}
          {dotStages[dotIndex]}
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '16px' }}>
          {current} / {total}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={percentage}
        color={color}
        sx={{ height: 10, borderRadius: 5, ...sx }}
      />
    </Box>
  );
};

export default ProgressBar;
